const routes = [
    {
        path: "/placement/exam/scores/import/:id",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "placementexamscore_import"
        }
    }
];

export default routes;
